export const VAULT_BUCKETS = [
	'Borrower Portal Document Vault',
	'Partner Portal Document Vault',
	'Settlement Agent Vault',
]
